import { Logger, LoggerService } from '@Shared/logger';
import { Screen } from './screen.base';
import { OptionsModule } from '@Modules/options_module';
import { UIModule } from '@Modules/ui_module/ui.module';
import { Alert } from '@Modules/ui_module/components/alert/alert.component';
import { ResetPasswordFormData, ResetPasswordPayload } from './models';
import { AsyncUtils } from '@Shared/utils/async';
import { HttpService } from '@Shared/http/http.service';
import { SETTINGS } from '@Config';
import { ServerResponse } from '@Shared/http/http.models';

export class ResetPasswordScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger('ResetPasswordScreen');

  constructor() {
    super();
    this.Logger.trace('****  CTOR ****');

    this._html = UIModule.HTML.resetPasswordForm;
    this._screenOptions = OptionsModule.Options.ui.screens.resetPassword;
    this._alert = new Alert();
  }

  show(): void {
    super.show();
    this.Logger.trace('show called');
    this.handleForm();
    this._formSubmitHandler = this._form?.onSubmit<ResetPasswordFormData>(
      async (data) => {
        this.Logger.trace('Form submitted with data:', data);

        try {
          this._alert.hide();

          const response = await this.sendPasswordResetEmail(data.email);

          if (response.success) {
            this._alert.success('Success!');
          } else {
            this.Logger.error(
              'Failed to send password reset email:',
              response.error,
            );
            this._alert.error(
              'We were unable to send you an email with instructions.',
            );
          }
        } catch (error) {
          this.Logger.error('Reset password error', error);
          this._alert.error(
            'We were unable to send you an email with instructions.',
          );
        } finally {
          await AsyncUtils.delay(1000);
          this._form?.enable();
        }
      },
    );
  }

  async sendPasswordResetEmail(email: string): Promise<ServerResponse<void>> {
    this.Logger.trace('Sending password reset email to:', email);
    const resetPasswordPayload: ResetPasswordPayload = {
      siteURL: OptionsModule.Options.domain,
      auth0ClientId: OptionsModule.Options.auth.clientId,
      userEmail: email,
      includeLoginLink: true,
    };
    this.Logger.trace('Submitting Request With Payload:', resetPasswordPayload);
    const httpService = new HttpService(SETTINGS.entitler.baseUrl, 0);
    const response = await httpService.post2<void>(
      'auth0/sendNoAccountEmail',
      resetPasswordPayload,
      SETTINGS.entitler.apiKey,
    );
    this.Logger.trace('Reset password response:', response);
    return response;
  }
}
